var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 196 196",
    style: {
      enableBackground: "new 0 0 196 196"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,68C17.4,68.5,4.5,82.4,5,99s14.4,29.5,31,29c16.6-0.6,29.5-14.4,29-31c-0.5-15.8-13.2-28.5-29-29H34z  M76,68c-16.6,0.6-29.5,14.4-29,31s14.4,29.5,31,29c16.6-0.6,29.5-14.4,29-31c-0.5-15.8-13.2-28.5-29-29H76z M118,68 c-16.6,0.6-29.5,14.4-29,31s14.4,29.5,31,29c16.6-0.6,29.5-14.4,29-31c-0.5-15.8-13.2-28.5-29-29H118z M160,68 c-16.6,0.6-29.5,14.4-29,31c0.6,16.6,14.4,29.5,31,29c16.6-0.6,29.5-14.4,29-31c-0.5-15.8-13.2-28.5-29-29H160z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudi);
export default __webpack_public_path__ + "static/media/audi.1af89772af249b18fc77cd88ef67016a.svg";
export { ForwardRef as ReactComponent };